import ATSplitText from '@activetheory/split-text'
import GSAPSplitText from 'gsap/dist/SplitText'
import { forEach } from 'lodash'

export const SplitTextEngine = {
  GSAP: 'GSAP',
  AT: 'AT'
} as const

export type SplitTextEngine = keyof typeof SplitTextEngine
export type SplitTextInstance = GSAPSplitText | ATSplitText
export type SplitTextLines = Element[] | string[]
export type SplitTextStagger = (
  // eslint-disable-next-line no-unused-vars
  stagger: number
) => gsap.StaggerVars | gsap.NumberValue

export type SplitText = {
  instance: SplitTextInstance
  engine: SplitTextEngine
  lines: SplitTextLines
  getStagger: SplitTextStagger
  revert: () => void
}

export const splitLines = (
  target: HTMLElement,
  engine: SplitTextEngine = SplitTextEngine.GSAP
): SplitText => {
  let instance: SplitTextInstance

  if (engine === 'AT') {
    instance = new ATSplitText(target, {
      type: 'lines,words',
      noBalance: true
    })
  } else {
    instance = new GSAPSplitText(target, {
      type: 'lines',
      linesClass: 'gsap-line'
    })

    new GSAPSplitText(target, {
      type: 'lines',
      linesClass: 'gsap-line-wrap'
    })
  }

  forEach(instance.lines, (line: any) => {
    if (line.innerHTML.length === 1) {
      line.innerHTML = '&nbsp;'
    }
  })

  const lines: SplitTextLines =
    engine === SplitTextEngine.AT ? instance.words : instance.lines

  const getStagger: SplitTextStagger = (stagger) =>
    engine === SplitTextEngine.AT
      ? (_, target) => stagger * target.__lineIndex
      : { amount: stagger }

  return {
    instance,
    engine,
    lines,
    getStagger,
    revert: () => instance.revert()
  }
}
